module.exports = __webpack_public_path__ + "static/media/main.769a53e7.png";